export const zones = [
  {
    name: "Ablon-sur-Seine",
    slug: "ablon-sur-seine",
    postalCode: "94480",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Ablon-sur-Seine (94480).",
  },
  {
    name: "Alfortville",
    slug: "alfortville",
    postalCode: "94140",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Alfortville (94140).",
  },
  {
    name: "Arcueil",
    slug: "arcueil",
    postalCode: "94110",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Arcueil (94110).",
  },
  {
    name: "Boissy-Saint-Léger",
    slug: "boissy-saint-leger",
    postalCode: "94470",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Boissy-Saint-Léger (94470).",
  },
  {
    name: "Bonneuil-sur-Marne",
    slug: "bonneuil-sur-marne",
    postalCode: "94380",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Bonneuil-sur-Marne (94380).",
  },
  {
    name: "Bry-sur-Marne",
    slug: "bry-sur-marne",
    postalCode: "94360",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Bry-sur-Marne (94360).",
  },
  {
    name: "Cachan",
    slug: "cachan",
    postalCode: "94230",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Cachan (94230).",
  },
  {
    name: "Champigny-sur-Marne",
    slug: "champigny-sur-marne",
    postalCode: "94500",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Champigny-sur-Marne (94500).",
  },
  {
    name: "Charenton-le-Pont",
    slug: "charenton-le-pont",
    postalCode: "94220",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Charenton-le-Pont (94220).",
  },
  {
    name: "Chennevières-sur-Marne",
    slug: "chennevieres-sur-marne",
    postalCode: "94430",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Chennevières-sur-Marne (94430).",
  },
  {
    name: "Chevilly-Larue",
    slug: "chevilly-larue",
    postalCode: "94550",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Chevilly-Larue (94550).",
  },
  {
    name: "Choisy-le-Roi",
    slug: "choisy-le-roi",
    postalCode: "94600",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Choisy-le-Roi (94600).",
  },
  {
    name: "Créteil",
    slug: "creteil",
    postalCode: "94000",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Créteil (94000).",
  },
  {
    name: "Fontenay-sous-Bois",
    slug: "fontenay-sous-bois",
    postalCode: "94120",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Fontenay-sous-Bois (94120).",
  },
  {
    name: "Fresnes",
    slug: "fresnes",
    postalCode: "94260",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Fresnes (94260).",
  },
  {
    name: "Gentilly",
    slug: "gentilly",
    postalCode: "94250",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Gentilly (94250).",
  },
  {
    name: "L'Haÿ-les-Roses",
    slug: "l-hay-les-roses",
    postalCode: "94240",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à L'Haÿ-les-Roses (94240).",
  },
  {
    name: "Ivry-sur-Seine",
    slug: "ivry-sur-seine",
    postalCode: "94200",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Ivry-sur-Seine (94200).",
  },
  {
    name: "Joinville-le-Pont",
    slug: "joinville-le-pont",
    postalCode: "94340",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Joinville-le-Pont (94340).",
  },
  {
    name: "Le Kremlin-Bicêtre",
    slug: "le-kremlin-bicetre",
    postalCode: "94270",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Le Kremlin-Bicêtre (94270).",
  },
  {
    name: "Le Perreux-sur-Marne",
    slug: "le-perreux-sur-marne",
    postalCode: "94170",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Le Perreux-sur-Marne (94170).",
  },
  {
    name: "Le Plessis-Trévise",
    slug: "le-plessis-trevise",
    postalCode: "94420",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Le Plessis-Trévise (94420).",
  },
  {
    name: "La Queue-en-Brie",
    slug: "la-queue-en-brie",
    postalCode: "94510",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à La Queue-en-Brie (94510).",
  },
  {
    name: "Limeil-Brévannes",
    slug: "limeil-brevannes",
    postalCode: "94450",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Limeil-Brévannes (94450).",
  },
  {
    name: "Maisons-Alfort",
    slug: "maisons-alfort",
    postalCode: "94700",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Maisons-Alfort (94700).",
  },
  {
    name: "Mandres-les-Roses",
    slug: "mandres-les-roses",
    postalCode: "94520",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Mandres-les-Roses (94520).",
  },
  {
    name: "Marolles-en-Brie",
    slug: "marolles-en-brie",
    postalCode: "94440",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Marolles-en-Brie (94440).",
  },
  {
    name: "Nogent-sur-Marne",
    slug: "nogent-sur-marne",
    postalCode: "94130",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Nogent-sur-Marne (94130).",
  },
  {
    name: "Noiseau",
    slug: "noiseau",
    postalCode: "94880",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Noiseau (94880).",
  },
  {
    name: "Orly",
    slug: "orly",
    postalCode: "94310",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Orly (94310).",
  },
  {
    name: "Ormesson-sur-Marne",
    slug: "ormesson-sur-marne",
    postalCode: "94490",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Ormesson-sur-Marne (94490).",
  },
  {
    name: "Périgny",
    slug: "perigny",
    postalCode: "94520",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Périgny (94520).",
  },
  {
    name: "Rungis",
    slug: "rungis",
    postalCode: "94150",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Rungis (94150).",
  },
  {
    name: "Saint-Mandé",
    slug: "saint-mande",
    postalCode: "94160",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Saint-Mandé (94160).",
  },
  {
    name: "Saint-Maur-des-Fossés",
    slug: "saint-maur-des-fosses",
    postalCode: "94100",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Saint-Maur-des-Fossés (94100).",
  },
  {
    name: "Saint-Maurice",
    slug: "saint-maurice",
    postalCode: "94410",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Saint-Maurice (94410).",
  },
  {
    name: "Santeny",
    slug: "santeny",
    postalCode: "94440",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Santeny (94440).",
  },
  {
    name: "Sucy-en-Brie",
    slug: "sucy-en-brie",
    postalCode: "94370",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Sucy-en-Brie (94370).",
  },
  {
    name: "Thiais",
    slug: "thiais",
    postalCode: "94320",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Thiais (94320).",
  },
  {
    name: "Valenton",
    slug: "valenton",
    postalCode: "94460",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Valenton (94460).",
  },
  {
    name: "Villecresnes",
    slug: "villecresnes",
    postalCode: "94440",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Villecresnes (94440).",
  },
  {
    name: "Villejuif",
    slug: "villejuif",
    postalCode: "94800",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Villejuif (94800).",
  },
  {
    name: "Villeneuve-le-Roi",
    slug: "villeneuve-le-roi",
    postalCode: "94290",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Villeneuve-le-Roi (94290).",
  },
  {
    name: "Villeneuve-Saint-Georges",
    slug: "villeneuve-saint-georges",
    postalCode: "94190",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Villeneuve-Saint-Georges (94190).",
  },
  {
    name: "Villiers-sur-Marne",
    slug: "villiers-sur-marne",
    postalCode: "94350",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Villiers-sur-Marne (94350).",
  },
  {
    name: "Vincennes",
    slug: "vincennes",
    postalCode: "94300",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Vincennes (94300).",
  },
  {
    name: "Vitry-sur-Seine",
    slug: "vitry-sur-seine",
    postalCode: "94400",
    priority: true,
    description: "Interventions rapides en dépannage alu/métal à Vitry-sur-Seine (94400).",
  },
  {
    name: "Antony",
    slug: "antony",
    postalCode: "92160",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Antony (92160).",
  },
  {
    name: "Versailles",
    slug: "versailles",
    postalCode: "78000",
    priority: false,
    description: "Interventions rapides en dépannage alu/métal à Versailles (78000).",
  },
];

export const priorityZones = zones.filter((zone) => zone.priority);

export const otherZones = zones.filter((zone) => !zone.priority);
